import * as React from "react";
const SvgSettings = (props) => (
  <svg
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.176 2.837c.379-1.561 2.599-1.561 2.978 0a1.532 1.532 0 0 0 2.286.947c1.372-.836 2.942.734 2.106 2.106a1.532 1.532 0 0 0 .947 2.286c1.561.379 1.561 2.599 0 2.978a1.532 1.532 0 0 0-.947 2.286c.836 1.372-.734 2.942-2.106 2.106a1.532 1.532 0 0 0-2.286.947c-.379 1.561-2.599 1.561-2.978 0a1.532 1.532 0 0 0-2.286-.947c-1.372.836-2.942-.734-2.106-2.106a1.532 1.532 0 0 0-.947-2.286c-1.561-.379-1.561-2.599 0-2.978a1.532 1.532 0 0 0 .947-2.286c-.836-1.372.734-2.942 2.106-2.106.886.54 2.041.061 2.286-.947Z"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.331 9.665a2.666 2.666 0 1 1-5.332 0 2.666 2.666 0 0 1 5.332 0Z"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgSettings;
